module.exports = __webpack_public_path__ + "img/About_One.3437cd7a.png";